import useStateAsync from 'hooks/useStateAsync';
import OnechipsService from 'services/onechips/Onechips';
import { generatePath, useNavigate } from 'react-router';
import { ROUTES } from 'routes/const';
import OnechipsSearch from 'components/top-section/components/OnechipsSearch';

import { trim } from 'lodash';

const OnechipsSearchContainer = () => {
  const navigate = useNavigate();

  const onechips = useStateAsync(OnechipsService.getOnechipsSearchList, {
    immediate: false,
  });

  const handleonSearch = (value) => {
    const values = value.split(/[,;\s]/g);
    if (values.length > 1) {
      return;
    }
    onechips.execute({ eid: values });
  };

  const handleOnSearchOptionSelect = (option, reason) => {
    if (reason !== 'selectOption') return;
    const { eid = null } = option;
    navigate(generatePath(ROUTES.ONECHIP_DETAILS.INDEX, { eid }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const values = (new FormData(e.target).get('search') || '')
      .trim()
      .split(/[,;\s]+/)
      .filter(Boolean);

    const query = new URLSearchParams();
    values.forEach((v) => query.append('filteredEids', v));

    navigate(`${ROUTES.ONECHIPS}?${query}`);
  };

  return (
    <OnechipsSearch
      loading={onechips.isLoading}
      data={onechips?.data?.data}
      onSearch={handleonSearch}
      onSelect={handleOnSearchOptionSelect}
      onSubmit={handleSubmit}
    />
  );
};

export default OnechipsSearchContainer;
